import React, { Component } from 'react'
import PropTypes from 'prop-types'

// Importing css
import './Modal.css'


// Render header part
const ModalHeader = (props) => (
  <div className="gdocs-modal-dialog__header" >
    <h2 className="gdocs-modal-dialog__header__title" id="modal-title">{props.title}</h2>
    {props.children}
  </div>
)

// Render body part
const ModalBody = (props) => (
  <div className="gdocs-modal-dialog__body" id="modal-body">
    {props.children}
  </div>
)

// Render footer part
const ModalFooter = (props) => (
  <div className="gdocs-modal-dialog__footer">
    {props.children}
  </div>
)

export { ModalHeader, ModalBody, ModalFooter }


// Render content
class ModalContent extends Component {
  constructor(props) {
    super(props)
    this.modalFocusRef = React.createRef();
    this.previousFocus = document.activeElement;
  }

  // life cycle hook
  componentDidMount() {
    document.addEventListener('keyup', this.handleEscKey);
    this.modalFocusRef.current.focus();
    document.addEventListener('focus', this.handleModalFocus, true);
    // this.previousFocus = document.activeElement;
    this.openDialog();
    const modal = document.querySelector('#modalPopup');

    var KEYCODE_TAB = 9;

    modal.addEventListener('keydown', function (e) {
      var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

      if (isTabPressed) {
        var focusableEls = modal.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
      }

      if (!isTabPressed) {
        return;
      }

      if (e.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          e.preventDefault();
        }
      }
      else /* tab */ {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          e.preventDefault();
        }
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('focus', this.handleModalFocus, true);
    if (this.previousFocus) {
      this.previousFocus.focus();
    }
  }
  handleModalFocus = (event) => {
    if (this.modalFocusRef.current && !this.modalFocusRef.current.contains(event.target)) {
      event.stopPropagation();
      this.modalFocusRef.current.focus();
    }
  }

  openDialog() {

    const focusableElements =
      'p,[href], input, select, label:not([class^=gdocs-modal-dialog]), textarea, [class]:not([class^=gdocs-modal-dialog]):not([class=gdoc-modal-separator]):not([class=delete-group-model--body]):not([class=gdocs-float-right]):not([class=login]):not([class=container-area]):not([class=app-container]):not([class=gdocs-btn-primary]):not([class^=icon]):not([class=login-details-form]):not([class*=login-details]):not([class=case-body-main-container]):not([class=gdoc-invite-collabrative]):not([class^=listContainer]):not([class=account-list]):not([class=product-details-container]):not([class=gdoc-tab-tab-content]):not([class=gdoc-tab-tabs]):not([class=left-case-body-container]):not([class=gls-list]):not([class=additional-data-list]):not([class=corporate-list]):not([class=echannel-list]):not([class=gdoc-caseDocument-container]):not([class=gls-activation-list]):not([class=gdocs-heading-bottom]):not([class=gdocs-activation-container]):not([class=product-account-container])';

    var nodeList = document.querySelectorAll(focusableElements);

    for (var j = 0; j < nodeList.length; j++) {
      nodeList[j].setAttribute('aria-hidden', true);
    }

    const modal = document.querySelector('#modalPopup');
    const focusableContent = Array.from(modal.querySelectorAll('p,button, [href], input, select, label, textarea,[class]'));
    for (var j = 0; j < focusableContent.length; j++) {
      focusableContent[j].removeAttribute('aria-hidden');
    }
  }

  closeDialog() {
    const focusableElements =
      'p,[href], input, select, label:not([class^=gdocs-modal-dialog]), textarea, [class]:not([class^=gdocs-modal-dialog]):not([class=gdoc-modal-separator]):not([class=delete-group-model--body]):not([class=gdocs-float-right]):not([class=login]):not([class=container-area]):not([class=app-container]):not([class=gdocs-btn-primary]):not([class^=icon]):not([class=login-details-form]):not([class*=login-details]):not([class=case-body-main-container]):not([class=gdoc-invite-collabrative]):not([class^=listContainer]):not([class=account-list]):not([class=product-details-container]):not([class=gdoc-tab-tab-content]):not([class=gdoc-tab-tabs]):not([class=left-case-body-container]):not([class=gls-list]):not([class=additional-data-list]):not([class=corporate-list]):not([class=echannel-list]):not([class=gdoc-caseDocument-container]):not([class=gls-activation-list]):not([class=gdocs-heading-bottom]):not([class=gdocs-activation-container]):not([class=product-account-container])';
    var nodeList = document.querySelectorAll(focusableElements);
    for (var j = 0; j < nodeList.length; j++) {
      nodeList[j].removeAttribute('aria-hidden');
    }
    setTimeout(() => {
      this.previousFocus !== undefined && this.previousFocus !== null && this.previousFocus.focus()
    }, 0);
  }

  // life cycle hook
  componentWillMount() {
    document.removeEventListener('keyup', this.handleEscKey)
  }

  componentWillUnmount() {
    this.closeDialog();
  }
  // Handle Esc key to close dialog
  handleEscKey = (e) => {
    this.props.onClose || this.props.removeDialogCloseHandlers &&
      (e.keyCode === 27) && this.props.onClose()
  }

  handleEnterKey = (e) => {
    this.props.onClose &&
      (e.keyCode === 13) && this.props.onClose()
  }

  // overlay close
  handleDialogCover = (e) => {
    this.props.onClose || this.props.removeDialogCloseHandlers && this.props.onClose()
  }

  // Render modal JSX
  render() {
    const { onClose, children, bsClass, removeDialogCloseHandlers } = this.props
    return (
      <div className="gdocs-modal-dialog" ref={this.modalFocusRef} tabIndex={0}>
        <div
          id="gdocs-modal-dialog__cover"
          className="gdocs-modal-dialog__cover"
          onClick={this.handleDialogCover}
        ></div>
        <div className={`gdocs-modal-dialog__content ${bsClass}`} id="modalPopup" aria-modal="true" aria-labelledby="modal-title" aria-describedby="modal-body" role="dialog">
          {
            removeDialogCloseHandlers !== 'false' ?
              <button id="gdocs-modal-close-btn"
                className="gdocs-modal-dialog__close"
                onClick={onClose}
                aria-label="Close Popup"
                style={{ border: "white", background: "white" }}><i
                  className="icon icon-delete"></i></button>
              : ''
          }
          {children}
        </div>

      </div>
    )
  }
}

// Gdoc Modal
const Modal = (props) => (
  <div>
    {
      props.show &&
      <ModalContent
        onClose={props.onClose} bsClass={props.bsClass} removeDialogCloseHandlers={props.removeDialogCloseHandlers}>
        {props.children}
      </ModalContent>
    }
  </div>
)

// Modal default prop-types
Modal.defaultProps = {
  show: false
}

// Modal prop-types
Modal.propTypes = {
  children: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool
}

// Exporting Modal
export default Modal



// WEBPACK FOOTER //
// ./src/components/common/Modal/index.js